import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "preview", "counter"]
  static values = { min: Number }

  preview() {
    const files = this.inputTarget.files
    this.previewTarget.innerHTML = ""
    if (files.length === 0) return

    Array.from(files).forEach(file => {
      if (!file.type.startsWith("image/")) return
      const reader = new FileReader()
      reader.onload = (e) => {
        const img = document.createElement("img")
        img.src = e.target.result
        img.className = "img-thumbnail me-2 mb-2"
        img.style.maxHeight = "100px"
        img.style.maxWidth = "100px"
        this.previewTarget.appendChild(img)
      }
      reader.readAsDataURL(file)
    })

    if (this.hasCounterTarget) {
      this.counterTarget.textContent = `${files.length} file(s) selected`
      if (this.hasMinValue && files.length < this.minValue) {
        this.counterTarget.textContent += ` (minimum ${this.minValue} required)`
        this.counterTarget.classList.add("text-warning")
      } else {
        this.counterTarget.classList.remove("text-warning")
      }
    }
  }
}
